// 测试
// const baseUrl = 'http://192.168.3.167:9002/';
/* const baseUrl = 'http://dev3.yotur.cn/crm/';
const baseUrl2 = 'http://192.168.10.21/ucloud-commerce-admin'; // 兼容后台的接口
const baseUrl3 = 'https://life.yotur.cn/corp/'; // 兼容后台的接口
const devCode = '?dev-mode=true';
const devCode2 = '?dev-mode=true&adminUser=2';
const iframeBaseUrlAdmin = 'http://192.168.10.21'; // iframe的host-admin后台 */

// 正式
const baseUrl = 'https://crm.yotur.cn/crm/';
// const baseUrl = 'http://192.168.3.62:8012/crm/';
const iframeBaseUrlAdmin = 'https://admin.yotur.cn';
const baseUrl2 = 'https://admin.yotur.cn/ucloud-admin-web/ucloud-commerce-admin';
const baseUrl3 = 'https://crm.yotur.cn/corp/';
const devCode = '?dev-mode=true';
const devCode2 = '?dev-mode=true';

// const baseUrl = 'http://192.168.3.57:8082/ucloud-commerce-admin'; // 李亮
// const baseUrl = 'http://192.168.3.20:8081/crm'; // 陈卓
// const baseUrl = 'http://192.168.3.201:9091/crm'; // 罗三
// const baseUrl = 'http://192.168.3.33:8888/crm'; // 李科好
// const baseUrl = 'http://192.168.3.77:8081/ucloud-commerce-admin'; // 张乐义
// const baseUrl = 'http://192.168.3.201:9999/admin'; // 赵国庆
// const iframeBaseUrlAdmin = 'http://192.168.3.65:8010';

export {
  baseUrl,
  baseUrl2,
  baseUrl3,
  devCode,
  devCode2,
  iframeBaseUrlAdmin
};



// WEBPACK FOOTER //
// ./src/http/baseUrl.js